import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const FaListAlt = require("react-icons/fa").FaListAlt;
const FaRegCopy = require("react-icons/fa").FaRegCopy;
const FaCaretDown = require("react-icons/fa").FaCaretDown;
const FaPencilAlt = require('react-icons/fa').FaPencilAlt;

interface DraftMeetingDetailsProps {
  title: string;
  htmlContent: string;
  rawContent: string;
  isOpen: boolean;
  onToggle: () => void;
  onSave: (updatedHtml: string) => Promise<void>;
}

const DraftMeetingSummary: React.FC<DraftMeetingDetailsProps> = ({
  title,
  htmlContent,
  rawContent,
  isOpen,
  onToggle,
  onSave,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentContent, setCurrentContent] = useState(htmlContent);

  useEffect(() => {
    setCurrentContent(htmlContent);
  }, [htmlContent]);

  const handleCopy = (htmlString: string) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    const plainText = tempElement.textContent || tempElement.innerText || "";

    navigator?.clipboard
      ?.writeText(plainText)
      .then(() => toast.success("Copied to clipboard!"))
      .catch(() => toast.error("Failed to copy!"));
  };

  const handleSaveSubmit = async () => {
    await onSave(currentContent);
    setIsEditing(false);
  };


  return (
    <div className="my-3">
      <div
        className="content-output-container for-summary mt-3"
        onClick={onToggle}
        style={{ cursor: "pointer" }}
      >
        <div className="content-output-text">
          <div className="first-final-icon">
            <FaListAlt />
          </div>
          <p className="first-final-text">{title}</p>
        </div>

        <div className="icons-actions">
          <div
            className="icon-with-label"
            onClick={(e) => {
              e.stopPropagation();
              handleCopy(currentContent);
            }}
          >
            <FaRegCopy />
            <span className="icon-label">Copy</span>
          </div>

          {/* Hide edit option when editor is active */}
          {!isEditing && (
            <div
              className="icon-with-label"
              onClick={(e) => {
                e.stopPropagation();
                if (!isOpen) onToggle();
                setIsEditing(true);
              }}
            >
              <FaPencilAlt />
              <span className="icon-label">Edit</span>
            </div>
          )}

          <FaCaretDown
            style={{
              cursor: "pointer",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>
      </div>

      {/* Accordion Expansion Block */}
      {isOpen && (
        <div className="result-content bhashini-skip-translation">
          {!isEditing ? (
            /* Text Display Mode */
            <div dangerouslySetInnerHTML={{ __html: currentContent || `<div class="text-muted">No Summary Content is Available.</div>` }} />
          ) : (
            /* Rich Text Editor Mode */
            <div className="dds">
              <CKEditor
                editor={ClassicEditor as any}
                data={currentContent || "<p>Start typing...</p>"}
                onChange={(event, editor) => {
                  setCurrentContent(editor.getData());
                }}
              />
              <div className="m-3 d-flex justify-content-end" style={{ gap: "10px", display: "flex" }}>
              
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleSaveSubmit}
                >
                  Save
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DraftMeetingSummary;